import {moment} from "@/src/modules/core/lib";

import type {Shift, ShiftBreak} from "../types";

function isBreakAvailable(shiftBreak: ShiftBreak) {
  const now = moment();
  const breakDate = moment(shiftBreak.execution_start_datetime);

  return (
    (breakDate.isSameOrBefore(now) && shiftBreak.status === "scheduled") ||
    shiftBreak.status === "active"
  );
}

/** API may return `null` entries in `breaks`; never dereference `shift_break_id` on those. */
export function isValidShiftBreak(value: unknown): value is ShiftBreak {
  if (!value || typeof value !== "object") return false;
  const breakItem = value as ShiftBreak;
  return typeof breakItem.shift_break_id === "number" && Number.isFinite(breakItem.shift_break_id);
}

export function getShiftBreaks(shift: Pick<Shift, "breaks"> | null | undefined): ShiftBreak[] {
  if (!shift?.breaks?.length) return [];
  return shift.breaks.filter(isValidShiftBreak);
}

export function hasScheduledShiftBreaks(
  shift: Pick<Shift, "breaks"> | null | undefined,
): boolean {
  return getShiftBreaks(shift).some((breakItem) => breakItem.status === "scheduled");
}

export function findActiveShiftBreak(shift: Shift | null | undefined): ShiftBreak | null {
  return (
    getShiftBreaks(shift).find(
      (breakItem) => breakItem.status === "active" && isBreakAvailable(breakItem),
    ) ?? null
  );
}

export function normalizeShiftBreaks<T extends Pick<Shift, "breaks">>(shift: T): T {
  return {
    ...shift,
    breaks: getShiftBreaks(shift),
  };
}
